var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardManager(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2261_1566)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2261_1566",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 512,
    height: 512
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 0H0V512H512V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2261_1566)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.332 0H37.332C16.746 0 0 16.746 0 37.332V133.332C0 153.922 16.746 170.668 37.332 170.668H197.332C217.922 170.668 234.668 153.922 234.668 133.332V37.332C234.668 16.746 217.922 0 197.332 0ZM197.332 213.332H37.332C16.746 213.332 0 230.078 0 250.668V474.668C0 495.254 16.746 512 37.332 512H197.332C217.922 512 234.668 495.254 234.668 474.668V250.668C234.668 230.078 217.922 213.332 197.332 213.332ZM474.668 341.332H314.668C294.078 341.332 277.332 358.078 277.332 378.668V474.668C277.332 495.254 294.078 512 314.668 512H474.668C495.254 512 512 495.254 512 474.668V378.668C512 358.078 495.254 341.332 474.668 341.332ZM474.668 0H314.668C294.078 0 277.332 16.746 277.332 37.332V261.332C277.332 281.922 294.078 298.668 314.668 298.668H474.668C495.254 298.668 512 281.922 512 261.332V37.332C512 16.746 495.254 0 474.668 0Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2261_1566"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardManager);
export default __webpack_public_path__ + "static/media/dashboard-manager.ecf4dd09852dcc75399fa321beceb2c1.svg";
export { ForwardRef as ReactComponent };